import React from 'react';

export const useIsomorphicEffect = typeof document !== 'undefined' ? React.useLayoutEffect : React.useEffect;

const useBeforeUnload = (handler: (event: BeforeUnloadEvent) => void) => {
	const ref = React.useRef(handler);

	useIsomorphicEffect(() => {
		ref.current = handler;
	});

	React.useEffect(() => {
		const handleBeforeUnload = (event: BeforeUnloadEvent) => {
			const returnValue = ref.current != null ? ref.current(event) : null;

			// Chrome requires `returnValue` to be set.
			if (event.defaultPrevented) {
				event.returnValue = '';
			}

			if (typeof returnValue === 'string') {
				event.returnValue = returnValue;
				return returnValue;
			}

			return null;
		};

		window.addEventListener('beforeunload', handleBeforeUnload);

		return () => {
			window.removeEventListener('beforeunload', handleBeforeUnload);
		};
	}, [ref]);
};

export default useBeforeUnload;
